var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing-automation-detail-header-saving"},[_c('i',{staticClass:"mdi mdi-content-save-outline",class:{ 'cursor-wait': _vm.saving }}),_c('p',{staticClass:"text-bold marketing-automation-detail-header-saving-text"},[_vm._v("\n    "+_vm._s(_vm.saving ?  _vm.savingText : _vm.savedText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }